import { Typography } from '@design-system/components/typography/typography';
import { sectionItem, sectionWrapper, wrapper } from './Confirmation.css';
import { MigrationModalProps } from '../MigrationModal';
import { Button } from '@design-system/components/button/button';

export const Confirmation = ({
  dispatch,
}: Pick<MigrationModalProps, 'dispatch'>) => (
  <div className={wrapper}>
    <Typography variant="headline" size="large">
      Are you sure you want to switch?
    </Typography>
    <Typography variant="body" size="medium" fontWeight="normal" align="center">
      Switching to Exclusive subscription model is a permanent decision. You
      won’t be able to revert to the Platform only model.
    </Typography>
    <div className={sectionWrapper}>
      <div className={sectionItem}>
        <Typography variant="body" size="medium" fontWeight="normal">
          If you are not sure about things, please reach out and we'll help you
          make the right decision.
        </Typography>
        <Button
          onClick={() => dispatch('helpMaterialsEvent', 'chatSupport')}
          color="primaryTonal"
          data-intercom-target="chatWithSupportTarget"
          id="chatWithSupport"
          className="w-max"
        >
          Chat with Support
        </Button>
      </div>
      <div className={sectionItem}>
        <Typography variant="body" size="medium" fontWeight="normal">
          Get help in our Creator Community from our experts & other creators.
        </Typography>
        <a
          href="https://community.joinplaybook.com/c/start-here/"
          onClick={() => dispatch('helpMaterialsEvent', 'joinCommunity')}
          target="_blank"
          rel="noreferrer"
        >
          <Button color="primaryTonal" className="pointer-events-none">
            Join Community
          </Button>
        </a>
      </div>
    </div>
  </div>
);
